import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Ventas",
    items: [
      { label: "Prospectos",    icon: "fas fa-user-plus",  href: "/CrmProspectos",     key: "crm.prospectos.ver" },
      { label: "Oportunidades", icon: "fas fa-handshake",  href: "/CrmOportunidades",  key: "crm.oportunidades.ver" },
      { label: "Embudo Ventas",      icon: "fas fa-stream",     href: "/CrmPipeline",       key: "crm.embudo.ver" },
    ],
  },
  {
    title: "Reportes",
    items: [
      { label: "Acciones Pendientes", icon: "fas fa-calendar-check", href: "/CrmReportePendientes", key: "crm.pendientes.ver" },
    ],
  },
  {
    title: "Configuración",
    items: [
      { label: "Etapas",      icon: "fas fa-sliders-h", href: "/CrmEtapas",     key: "crm.etapas.ver" },
      { label: "Categorías",  icon: "fas fa-tags",      href: "/CrmCategorias", key: "crm.categorias.ver" },
    ],
  },
];

function BotonesCrm() {
  return (
    <MenuGrid
      title="CRM"
      subtitle="Prospectos, oportunidades y pipeline de ventas"
      icon="fas fa-bullseye"
      accent={{ color: "#8b5cf6", bg: "#f5f3ff" }}
      modulo="crm"
      sections={SECTIONS}
    />
  );
}

export default BotonesCrm;
